import { List } from 'immutable'
import { apiGet } from '../lib/api'

export const APP_SET_LOCATION = 'APP_SET_LOCATION'
export const APP_START = 'APP_START'
export const APP_STORAGE_LOAD = 'APP_STORAGE_LOAD'
export const TOGGLE_NAVIGATION = 'TOGGLE_NAVIGATION'
export const SET_SCROLL_LOCATION = 'SET_SCROLL_LOCATION'
export const SET_BACK_ANDROID_PRESS = 'SET_BACK_ANDROID_PRESS'
export const RESET_BACK_ANDROID_PRESS = 'RESET_BACK_ANDROID_PRESS'
export const APP_LOAD_VERSION_SUCCESS = 'APP_LOAD_VERSION_SUCCESS'

export const loadAppVersion = () => ({ getState, fetch }) => ({
  type: 'APP_LOAD_VERSION',
  payload: apiGet({
    fetch,
    endpoint: 'about/version',
    getState,
  }),
})

export const setLocation = (location) => ({
  type: APP_SET_LOCATION,
  payload: { location: new List(location.map((l) => `${l.pathname}${l.search}`)) },
})

export const setScrollLocation = (location) => ({
  type: SET_SCROLL_LOCATION,
  payload: { location },
})

export const setBackAndroidPress = (backAndroidPress) => ({
  type: SET_BACK_ANDROID_PRESS,
  payload: { backAndroidPress },
})

export const resetBackAndroidPress = () => ({
  type: RESET_BACK_ANDROID_PRESS,
})


export const start = () => {
  const loadStorage = async (dispatch, storageEngine) => {
    const state = await storageEngine.load()
    dispatch({ type: APP_STORAGE_LOAD, payload: state })
  }
  return ({ dispatch, storageEngine }) => {
    loadStorage(dispatch, storageEngine).finally(() => {})
    return {
      type: APP_START,
    }
  }
}

export const toggleNavigation = () => ({
  type: TOGGLE_NAVIGATION,
})



// WEBPACK FOOTER //
// ./src/common/app/actions.js